import React, { useState, useEffect } from "react";
import { DataStore } from "@aws-amplify/datastore";
import { Card, Button as BootstrapButton } from "react-bootstrap";
import { VehicleModelGeneralInfo } from "../models";

function Suggestions({ suggestions, onSuggestionSelect }) {
    return (
        <div className="disappear card mx-auto d-flex flex-column justify-content-between">
            {suggestions.map((suggestion, index) => (
                <div
                    key={index}
                    className="suggestion-item"
                    onClick={() => onSuggestionSelect(suggestion)}
                >
                    {suggestion.Manufacturer} {suggestion.ModelName}
                </div>
            ))}
        </div>
    );
}

export default function Bikes() {
    const [bikes, setBikes] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedBike, setSelectedBike] = useState(null);
    const [filteredSuggestions, setFilteredSuggestions] = useState([]);

    useEffect(() => {
        const searchInput = document.querySelector(".search-input");
        const suggestionsList = document.querySelector(".disappear");

        function handleClickOutside(event) {
            if (searchInput && !searchInput.contains(event.target) && suggestionsList && !suggestionsList.contains(event.target)) {
                setFilteredSuggestions([]);
            }
        }

        document.addEventListener("click", handleClickOutside);
        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        fetchBikes();
    }, []);

    async function fetchBikes() {
        try {
            const fetchedBikes = await DataStore.query(VehicleModelGeneralInfo);
            setBikes(fetchedBikes);
        } catch (error) {
            console.error("Error fetching bikes:", error);
        }
    }

    function filterBikes(bike, searchQuery) {
        const words = searchQuery.toLowerCase().split(" ");
        return (
            bike.VehicleType === "MOTORCYCLE" &&
            bike.Manufacturer &&
            bike.ModelName &&
            words.every(
                (word) =>
                    bike.Manufacturer.toLowerCase().includes(word) ||
                    bike.ModelName.toLowerCase().includes(word)
            )
        );
    }

    function handleInputChange(event) {
        const query = event.target.value;
        setSearchQuery(query);
        const suggestions = bikes.filter((bike) => filterBikes(bike, query));
        setFilteredSuggestions(suggestions);
    }

    function handleSuggestionSelect(suggestion) {
        setSelectedBike(suggestion);
        setFilteredSuggestions([]); // Clear suggestions
    }

    function toggleSuggestions() {
        if (filteredSuggestions.length > 0) {
            setFilteredSuggestions([]);
        } else {
            const motorcyclesOnly = bikes.filter(bike => bike.VehicleType === "MOTORCYCLE");
            setFilteredSuggestions(motorcyclesOnly);
        }
    }
    return (
        <div style={{ position: "relative" }}>
            <div style={{ display: "flex", flexDirection: "column" }}>
                <input
                    className="search-input card mx-auto d-flex flex-column justify-content-between"
                    type="text"
                    placeholder="Click here to see bikes or search bike models..."
                    value={searchQuery}
                    onChange={handleInputChange}
                    onClick={toggleSuggestions}
                    style={{ padding: "10px", marginBottom: "5px" }}
                />

                {filteredSuggestions.length > 0 && (
                    <Suggestions
                        suggestions={filteredSuggestions}
                        onSuggestionSelect={handleSuggestionSelect}
                    />
                )}
            </div>

            {selectedBike && (
                <div className="homepageCarousel">
                    <Card className="card mx-auto d-flex flex-column justify-content-between">
                        <div>
                            <Card.Img
                                variant="top"
                                src={selectedBike.Picture}
                                alt={`Slide Bike`}
                            />
                            <Card.Body className="card-body"
                                style={{ maxHeight: "400px", overflowY: "auto" }}>
                                <Card.Text>Vehicle Type: {selectedBike.VehicleType}</Card.Text>
                                <Card.Text>Body Style: {selectedBike.BodyStyle}</Card.Text>
                                <Card.Text>Engine Category: {selectedBike.EngineCategory}</Card.Text>
                                <Card.Text>Engine Size (cc): {selectedBike.EngineSize_cc}</Card.Text>
                                <Card.Text>Drivetrain: {selectedBike.Drivetrain}</Card.Text>
                                <Card.Text>General Dimensions (meters): {selectedBike.GeneralDimensions_meters}</Card.Text>
                                <Card.Text>Curb Weight (kg): {selectedBike.CurbWeight_kg}</Card.Text>
                                <Card.Text>Seating Capacity: {selectedBike.SeatingCapacity}</Card.Text>
                                <Card.Text>Acceleration (0 to 100 seconds): {selectedBike.Acceleration_0_to_100_in_seconds}</Card.Text>
                                <Card.Text>Top Speed (km/h): {selectedBike.TopSpeed_kmph}</Card.Text>
                                <Card.Text>Average Market Price (CAD): {selectedBike.AverageMarketPrice_CAD}</Card.Text>
                                <Card.Text>Safety Rating: {selectedBike.SafetyRating}</Card.Text>
                                <Card.Text>General information: {selectedBike.Information}</Card.Text>
                            </Card.Body>


                        </div>
                    </Card>
                </div>
            )}
        </div>
    );
}

